<template>
    <div>
        <v-snackbar
            v-for="(snackbar, index) in snackbars"
            :key="index"
            v-model="snackbar.visible"
            :timeout="snackbar.timeout"
            :color="snackbar.color"
            transition="v-snackbar-transition"
            multi-line
        >
            <div>
                <v-avatar v-if="snackbar.avatar_url" size="35" class="mr-2">
                    <v-img :src="snackbar.avatar_url"></v-img>
                </v-avatar>

                <Icon
                    v-if="snackbar.icon"
                    google
                    :size="snackbar.icon.size ?? '18'"
                    :color="snackbar.icon.color"
                >
                    {{ snackbar.icon.name }}
                </Icon>

                <div>
                    <h3
                        v-if="snackbar.title"
                        class="mb-2"
                        v-html="snackbar.title"
                    ></h3>
                    <p v-html="snackbar.message"></p>
                </div>
            </div>

            <template #actions>
                <v-btn
                    v-if="snackbar.button_text && snackbar.button_url"
                    color="white"
                    variant="text"
                    @click.prevent="
                        downloadFile(snackbar.button_url);
                        removeSnackbar(index);
                    "
                >
                    {{ snackbar.button_text }}
                </v-btn>

                <v-btn
                    color="white"
                    variant="text"
                    @click="removeSnackbar(index)"
                >
                    Close
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script setup>
import Utilities from "../../../Helpers/utilities";
const { snackbars } = Utilities();

function removeSnackbar(index) {
    snackbars.value.splice(index, 1);
}

function downloadFile(url) {
    const secureUrl = url.startsWith("http://")
        ? url.replace("http://", "https://")
        : url;
    const link = document.createElement("a");
    link.href = secureUrl;
    link.setAttribute("download", "");
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
}
</script>

<style scoped></style>
